import React, { useEffect } from "react";
import { Box, Text } from "theme-ui";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import InactivityTimer from "components/InactivityTimer/InactivityTimer";
import CustomerProvider from "providers/CustomerProvider/CustomerProvider";
import Start from "routes/Start/Start";
import Authenticate from "routes/Authenticate/Authenticate";
import Home from "routes/Home/Home";
import Service from "routes/Service/Service";
import Confirmation from "routes/Confirmation/Confirmation";
import Login from "./Login/Login";
import Offline from "./Offline/Offline";
// @ts-ignore
import useOnlineStatus from "@rehooks/online-status";
import Conference from "./Conference/Conference";
import { useAppSettings } from "providers/AppSettingsProvider/AppSettingsProvider";
import License from "./License/License";
import { useLicence } from "providers/LicenseProvider/LicenseProvider";
import { useAuthentication } from "providers/AuthenticationProvider/AuthenticationProvider";
import UserButtons from "UserButtons/UserButtons";
import { Trans } from "@lingui/react";
import Auth from "./Auth/Auth";
import { useAppSelector } from "store/store";
import { isAuthorised } from "store/authorisation";

const CustomerRoutes: React.FC = () => {
    return (
        <CustomerProvider>
            <Route path="/:companyId/:cutomerId" component={InactivityTimer} />
            <Route exact path="/:companyId/:customerId" component={Authenticate} />
            <Route exact path="/:companyId/:customerId/home" component={Home} />
            <Route
                exact
                path="/:companyId/:customerId/services/:serviceId"
                component={Service}
            />
            <Route
                exact
                path="/:companyId/:customerId/services/:serviceId/confirm"
                component={Confirmation}
            />
        </CustomerProvider>
    );
};

const CompanyRoutes: React.FC = () => {
    const appSettings = useAppSettings();
    return (
        <React.Fragment>
            {appSettings?.UseCase === "washing" || !appSettings?.UseCase ? (
                <Route exact path="/:companyId" component={Start} />
            ) : null}
            {appSettings?.UseCase === "conference" ? (
                <Route exact path="/:companyId" component={Conference} />
            ) : null}
        </React.Fragment>
    );
};

export interface RouteParams {
    companyId: string;
    customerId: string;
    serviceId: string;
    from: string;
    to: string;
}

const Routes = () => {

    return (
        <Switch>
            <Route path="/auth" component={Auth} />
            <Route
                exact
                path="/login"
                component={Login}
            />
            <Route exact path="/license" component={License} />
            <Route exact path="/:companyId/conference" component={Conference} />
            <Route
                exact
                path="/:companyId"
                component={CompanyRoutes}
            />
            <Route path="/:companyId/:customerId" component={CustomerRoutes} />
        </Switch>
    );
};

export default Routes;
